module.exports = __webpack_public_path__ + "media/src/images/icons/issue_colored-6f2d82502b9dc5dd243425741d2abb23.svg";